import axios from "axios";
import { keycloak } from "../../lib/keycloak/index";
import { InvoiceAmountCreateDTO, InvoiceAmountDTO, InvoiceAmountFilterDTO, InvoiceAmountFindAllResponseDTO, PartitionFiltersDTO, PartitionFindAllResponseDTO } from "./dto";
import { InvoiceAmountService } from "./service";

export class InvoiceAmountServiceImpl implements InvoiceAmountService {
    public findAllInvoiceAmount(filters: InvoiceAmountFilterDTO): Promise<InvoiceAmountFindAllResponseDTO> {
        let url: string = "/api/invoiceAmount/?" +
            "pageSize=" + filters.pageSize +
            "&sortBy=" + filters.sortBy +
            "&page=" + filters.page +
            "&sort=" + filters.sort
        return axios({
            url: url,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public createInvoiceAmount(body: InvoiceAmountCreateDTO): Promise<string> {
        return axios({
            method: 'POST',
            url: '/api/invoiceAmount/',
            data: body,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "POST",
            }
        }).then((response) => response.data)
    }

    public findByIdInvoiceAmount(id: string): Promise<InvoiceAmountDTO> {
        let url: string = "/api/invoiceAmount/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public editInvoiceAmount(id: string, body: InvoiceAmountCreateDTO): Promise<void> {
        return axios({
            method: 'PUT',
            url: '/api/invoiceAmount/' + id,
            data: body,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "POST",
            }
        }).then((response) => response.data)
    }

    public recoverPartitionMetrics(): Promise<void> {
        return axios({
            method: 'POST',
            url: '/api/partition/recover',
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "POST",
            }
        }).then((response) => response.data)
    }

    public partitionPartitionMetrics(): Promise<void> {
        return axios({
            method: 'POST',
            url: '/api/partition/manual',
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "POST",
            }
        }).then((response) => response.data)
    }

    public findAllPartition(filters: PartitionFiltersDTO): Promise<PartitionFindAllResponseDTO> {
        let url: string = "/api/partition/?" +
            "pageSize=" + filters.pageSize +
            "&sortBy=" + filters.sortBy +
            "&page=" + filters.page +
            "&sort=" + filters.sort +
            "&month=" + filters.month +
            "&year=" + filters.year
        return axios({
            url: url,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}